export default __webpack_public_path__ + "static/media/intro-pic4.67b728de.png";